// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Suites Page Styles */

.test-suites-container {
  padding: 0;
  width: 100%;
  max-width: 100%;
  margin: 0;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  overflow: visible;
}

.test-suites-header {
  margin-bottom: 2rem;
  flex-shrink: 0;
}

.test-suites-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.test-suites-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0;
}

/* Overview Controls */
.overview-controls {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.search-container {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 1rem;
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
}

.filter-container, .sort-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-container label, .sort-container label {
  font-weight: 500;
  color: var(--text-dark);
}

.filter-buttons, .sort-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.filter-btn, .sort-btn {
  padding: 0.5rem 0.75rem;
  background-color: white;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-btn:hover, .sort-btn:hover {
  background-color: #f1f3f5;
}

.filter-btn.active, .sort-btn.active {
  background-color: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

/* Overview Summary */
.overview-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.summary-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 1.25rem 1.35rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.summary-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color, #2563eb), transparent 85%);
}

.summary-card:hover {
  border-color: color-mix(in srgb, var(--primary-color, #2563eb) 30%, rgba(15, 23, 42, 0.08));
  box-shadow: 0 14px 28px -16px rgba(37, 99, 235, 0.35);
  transform: translateY(-1px);
}

.summary-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--primary-rgb), 0.12);
  color: var(--primary-color);
  border-radius: 12px;
  flex-shrink: 0;
}

.summary-content {
  display: flex;
  flex-direction: column;
}

.summary-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-dark);
}

.summary-label {
  font-size: 0.875rem;
  color: var(--text-muted);
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .overview-controls {
    flex-direction: row;
    align-items: flex-end;
  }
  
  .search-container {
    flex: 2 1;
  }
  
  .filter-container, .sort-container {
    flex: 1 1;
  }
}

.header-with-back {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 0.9rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary-color);
}

.project-filter {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 400px;
}

.project-filter label {
  font-weight: 500;
  color: var(--text-muted);
}

.project-filter select {
  flex: 1 1;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color);
}

.test-suites-subtitle {
  font-size: 1rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.test-suites-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

/* Test Suites Content Layout */
.test-suites-content {
  display: flex;
  gap: 2rem;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

/* Sidebar Styles */
.test-suites-sidebar {
  width: 300px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.test-suites-sidebar-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.test-suites-sidebar-pagination {
  flex-shrink: 0;
  padding-top: 0.75rem;
  margin-top: auto;
  border-top: 1px solid var(--border-color-light);
}

.test-suites-sidebar-pagination .pagination {
  margin: 0;
}

.test-suites-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color-light);
  flex-shrink: 0;
}

.test-suites-sidebar-header .sidebar-title {
  margin: 0;
  border-bottom: none;
}

.sidebar-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color-light);
}

.test-suites-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.test-suite-item-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  min-width: 0;
  overflow: hidden;
}

.test-suite-item-content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.test-suite-name-row {
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  margin-bottom: 8px;
  gap: 12px;
}

.test-suite-name-row .test-suite-name {
  flex: 1 1;
  min-width: 0;
}

.test-suite-name-count {
  flex-shrink: 0;
  font-size: 14px;
  color: #888;
}

.test-suite-stats-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.test-suite-status-chips {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.test-suite-stat-chip {
  border-radius: 8px;
  padding: 2px 8px;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
}

.test-suite-stat-chip.passed {
  background: #e6f7e6;
  color: #389e3d;
}

.test-suite-stat-chip.failed {
  background: #ffeaea;
  color: #d32f2f;
}

.test-suite-stat-chip.pending {
  background: #fffbe6;
  color: #b59f00;
}

.test-suite-item {
  flex: 1 1;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 0.75rem;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
}

.test-suite-item:hover {
  background-color: #f1f3f5;
}

.test-suite-item.active {
  background-color: #e9ecef;
  border-left: 3px solid var(--primary-color);
}

.test-suite-item-wrapper.active {
  border-left: 4px solid #7c3aed;
  background: #f4f2ff;
}

.test-suite-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.test-suite-name {
  font-weight: 600;
  color: var(--text-dark);
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-suite-pass-rate {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
}

.test-suite-pass-rate.high {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.test-suite-pass-rate.medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.test-suite-pass-rate.low {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.test-suite-item-stats {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.test-case-count {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.test-case-status {
  display: flex;
  gap: 0.75rem;
  font-size: 0.75rem;
}

.status-passed {
  color: #28a745;
}

.status-failed {
  color: #dc3545;
}

.status-pending {
  color: #ffc107;
}

/* Test Suite Details */
.test-suite-details {
  flex: 1 1;
  min-width: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.test-suite-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 1rem;
  min-width: 0;
}

.test-suite-header-info {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.test-suite-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.test-suite-description {
  color: var(--text-muted);
  margin: 0 0 1rem 0;
}

.test-suite-meta {
  display: flex;
  gap: 1.5rem;
  justify-content: flex-start !important;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.test-suite-actions {
  display: flex;
  gap: 0.75rem;
}

/* Test Cases List */
.test-cases-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;
  overflow-x: auto;
}

/* Test Cases */
.test-cases-container {
  margin-top: 1.5rem;
}

.test-cases-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.test-cases-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 0;
  margin-left: 15px;
  /* margin-bottom: 1rem; */
  /* padding-bottom: 0.5rem; */
  border-bottom: 1px solid var(--border-color-light);
}

.test-cases-table {
  width: 100%;
  border-collapse: collapse;
}

.test-cases-table th,
.test-cases-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light);
}

.test-cases-table th {
  font-weight: 600;
  color: var(--text-dark);
  background-color: #f8f9fa;
}

.test-cases-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Priority and Status Badges */
.priority-badge,
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.priority-high {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.priority-medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.priority-low {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

/* Priority Badge Colors - More Vibrant */
.priority-badge.priority-high {
  background-color: #ffebee;
  color: #c62828;
}

.priority-badge.priority-medium {
  background-color: #fff8e1;
  color: #f57f17;
}

.priority-badge.priority-low {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-passed {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.status-failed {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.status-pending {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

/* Status Badge Colors - More Vibrant */
.status-badge.status-passed {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-badge.status-failed {
  background-color: #ffebee;
  color: #c62828;
}

.status-badge.status-pending {
  background-color: #fff8e1;
  color: #f57f17;
}

/* Test Case Row for Draggable List */
.test-case-row {

  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0;
  background-color: white;
  border-radius: 0;
  border-bottom: 1px solid #f0f0f0;
  padding: 0.75rem 0;
  transition: all 0.2s ease;
  min-height: 40px; /* Minimum height for consistency */
}

.test-case-row:hover {
  background-color: #fafafa;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.drag-handle {
  padding: 0 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #eee;
  cursor: grab;
  height: 100%;
  align-self: stretch;
  opacity: 0.5;
}

.drag-handle:hover {
  color: #999;
  opacity: 1;
}

.test-case-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding: 0;
  gap: 1rem;
}

.test-case-id {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-right: 1rem;
  margin-left: 1rem;
  flex: 0 0 auto; /* Don't grow or shrink */
  width: 50px;
}

.test-case-name {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1; /* Take up remaining space */
  margin-right: 1rem;
}

.priority-badge, .status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-right: 1rem;
}

/* Test Case Actions */
.test-case-actions {
  display: flex;
  gap: 0.75rem;
  margin-left: auto;
}

.action-btn {
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: all 0.2s ease;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.action-btn.run:hover {
  color: #6f42c1;
}

.action-btn.view:hover {
  color: #17a2b8;
}

.action-btn.edit:hover {
  color: #28a745;
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}

.empty-state-icon {
  color: var(--border-color);
  margin-bottom: 1.5rem;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.empty-state-description {
  color: var(--text-muted);
  margin-bottom: 1.5rem;
  max-width: 400px;
}

/* Test Suites Overview */
.test-suites-overview-container {
  padding: 1rem;
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.projects-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.project-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  overflow: hidden;
}

.project-header {
  margin-bottom: 1rem;
}

.project-header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.expand-toggle {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-muted);
}

.expand-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary-color);
}

.expand-toggle.expanded svg {
  transform: rotate(180deg);
}

.project-content {
  display: none;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.project-content.expanded {
  display: block;
  opacity: 1;
  height: auto;
  overflow: visible;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.project-name {
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--text-dark);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.project-name:hover {
  color: var(--primary-color);
}

.project-description {
  color: var(--text-muted);
  margin: 0;
}

.project-stats {
  display: flex;
  gap: 2rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.stat-value {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark);
}

.pass-rate {
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
}

.pass-rate.high {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.pass-rate.medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.pass-rate.low {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.test-suites-table-container {
  margin-bottom: 1.5rem;
  overflow-x: auto;
}

.test-suites-table {
  width: 100%;
  border-collapse: collapse;
}

.test-suites-table th,
.test-suites-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light);
}

.test-suites-table th {
  font-weight: 600;
  color: var(--text-dark);
  background-color: #f8f9fa;
}

.test-suites-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.test-suite-name-cell {
  font-weight: 500;
  color: var(--text-dark);
  cursor: pointer;
}

.test-suite-name-cell:hover {
  color: var(--primary-color);
}

.pass-rate-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.pass-rate-badge.high {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.pass-rate-badge.medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.pass-rate-badge.low {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.test-suite-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn.delete:hover {
  color: #dc3545;
}

.project-footer {
  display: flex;
  justify-content: flex-end;
}

/* Small Button */
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

/* Action Feedback */
.action-feedback {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  z-index: 2000;
  animation: slideIn 0.3s ease;
  max-width: 400px;
}

.action-feedback.success {
  border-left: 4px solid #28a745;
}

.action-feedback.error {
  border-left: 4px solid #dc3545;
}

.action-feedback.info {
  border-left: 4px solid #17a2b8;
}

.action-feedback button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #6c757d;
}

.action-feedback button:hover {
  color: #343a40;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* AI Test Cases Modal */
.add-test-cases-modal {
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
}

.test-cases-filter {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.selection-summary {
  margin: 1rem 0;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-weight: 500;
}

.ai-test-cases-list {
  max-height: 50vh;
  overflow-y: auto;
  padding: 0.5rem;
  border: 1px solid var(--border-color-light);
  border-radius: 4px;
}

.ai-test-case-item {
  background-color: white;
  border: 1px solid var(--border-color-light);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ai-test-case-item:hover {
  border-color: var(--border-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.ai-test-case-item.selected {
  border-color: var(--primary-color);
  background-color: rgba(var(--primary-rgb), 0.05);
}

.test-case-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.test-case-name-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.test-case-name {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.test-case-meta {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.ai-confidence {
  font-size: 0.85rem;
  color: var(--text-muted);
  background-color: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
}

.test-case-description {
  color: var(--text-muted);
  margin-bottom: 1rem;
}

.test-case-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 0.9rem;
}

.test-case-section h4 {
  font-size: 0.9rem;
  margin: 0 0 0.5rem 0;
  color: var(--text-dark);
}

.test-case-section pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
  background-color: #f8f9fa;
  padding: 0.5rem;
  border-radius: 4px;
  color: var(--text-muted);
}

.selection-count {
  font-weight: 500;
}

.modal-actions {
  display: flex;
  gap: 1rem;
}

/* Drag and Drop Styles */
.draggable-item {
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
}

.draggable-item.dragging {
  opacity: 0.5;
}

.drop-indicator {
  height: 2px;
  background-color: #7c3aed;
  margin: 4px 0;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.drag-handle {
  cursor: grab;
  color: var(--text-muted);
  padding: 0.25rem;
  border-radius: 4px;
}

.drag-handle:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--text-dark);
}

.drag-handle svg {
  display: block;
}

/* Drag and drop specific styles */
.test-suite-item-wrapper.dragging {
  opacity: 0.5;
  background: #f8f9fa;
}

.test-suite-drop-indicator {
  height: 2px;
  background-color: #7c3aed;
  margin: 4px 0;
}

.test-suite-drag-handle {
  cursor: grab;
  color: #666;
  padding: 0.25rem;
  margin-right: 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .test-suites-content {
    flex-direction: column;
    height: auto;
  }
  
  .test-suites-sidebar {
    width: 100%;
    height: auto;
    max-height: 400px;
  }
}

@media (max-width: 768px) {
  .test-suites-header-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .test-suites-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  
  .test-suite-header {
    flex-direction: column;
    gap: 1rem;
  }
  
  .test-suite-actions {
    width: 100%;
  }
}

@media (max-width: 700px) {
  .test-case-row {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/test-suites.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;EAC1D,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;EAC5C,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kFAAkF;AACpF;;AAEA;EACE,2FAA2F;EAC3F,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,yBAAyB;EAIzB,wCAAwC;AAH1C;;AAMA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAE,yBAAyB;EACzC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO,EAAE,4BAA4B;EACrC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EAeE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAb3B;;AAgBA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Test Suites Page Styles */\n\n.test-suites-container {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 0;\n  overflow: visible;\n}\n\n.test-suites-header {\n  margin-bottom: 2rem;\n  flex-shrink: 0;\n}\n\n.test-suites-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.test-suites-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n/* Overview Controls */\n.overview-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.search-container {\n  position: relative;\n  width: 100%;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n}\n\n.filter-container, .sort-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filter-container label, .sort-container label {\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.filter-buttons, .sort-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.filter-btn, .sort-btn {\n  padding: 0.5rem 0.75rem;\n  background-color: white;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.filter-btn:hover, .sort-btn:hover {\n  background-color: #f1f3f5;\n}\n\n.filter-btn.active, .sort-btn.active {\n  background-color: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n/* Overview Summary */\n.overview-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.summary-card {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  padding: 1.25rem 1.35rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.summary-card::before {\n  content: '';\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--primary-color, #2563eb), transparent 85%);\n}\n\n.summary-card:hover {\n  border-color: color-mix(in srgb, var(--primary-color, #2563eb) 30%, rgba(15, 23, 42, 0.08));\n  box-shadow: 0 14px 28px -16px rgba(37, 99, 235, 0.35);\n  transform: translateY(-1px);\n}\n\n.summary-icon {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(var(--primary-rgb), 0.12);\n  color: var(--primary-color);\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.summary-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.summary-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.summary-label {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n/* Responsive adjustments */\n@media (min-width: 768px) {\n  .overview-controls {\n    flex-direction: row;\n    align-items: flex-end;\n  }\n  \n  .search-container {\n    flex: 2;\n  }\n  \n  .filter-container, .sort-container {\n    flex: 1;\n  }\n}\n\n.header-with-back {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--primary-color);\n}\n\n.project-filter {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: 400px;\n}\n\n.project-filter label {\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.project-filter select {\n  flex: 1;\n  padding: 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n}\n\n.test-suites-subtitle {\n  font-size: 1rem;\n  color: var(--text-muted);\n  margin-top: 0.5rem;\n}\n\n.test-suites-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n\n/* Test Suites Content Layout */\n.test-suites-content {\n  display: flex;\n  gap: 2rem;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* Sidebar Styles */\n.test-suites-sidebar {\n  width: 300px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 1rem;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.test-suites-sidebar-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.test-suites-sidebar-pagination {\n  flex-shrink: 0;\n  padding-top: 0.75rem;\n  margin-top: auto;\n  border-top: 1px solid var(--border-color-light);\n}\n\n.test-suites-sidebar-pagination .pagination {\n  margin: 0;\n}\n\n.test-suites-sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color-light);\n  flex-shrink: 0;\n}\n\n.test-suites-sidebar-header .sidebar-title {\n  margin: 0;\n  border-bottom: none;\n}\n\n.sidebar-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n.test-suites-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.test-suite-item-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.test-suite-item-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.test-suite-name-row {\n  width: 100%;\n  max-width: 100%;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  margin-bottom: 8px;\n  gap: 12px;\n}\n\n.test-suite-name-row .test-suite-name {\n  flex: 1;\n  min-width: 0;\n}\n\n.test-suite-name-count {\n  flex-shrink: 0;\n  font-size: 14px;\n  color: #888;\n}\n\n.test-suite-stats-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.test-suite-status-chips {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.test-suite-stat-chip {\n  border-radius: 8px;\n  padding: 2px 8px;\n  font-weight: 500;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.test-suite-stat-chip.passed {\n  background: #e6f7e6;\n  color: #389e3d;\n}\n\n.test-suite-stat-chip.failed {\n  background: #ffeaea;\n  color: #d32f2f;\n}\n\n.test-suite-stat-chip.pending {\n  background: #fffbe6;\n  color: #b59f00;\n}\n\n.test-suite-item {\n  flex: 1;\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 0.75rem;\n  background-color: #f8f9fa;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.test-suite-item:hover {\n  background-color: #f1f3f5;\n}\n\n.test-suite-item.active {\n  background-color: #e9ecef;\n  border-left: 3px solid var(--primary-color);\n}\n\n.test-suite-item-wrapper.active {\n  border-left: 4px solid #7c3aed;\n  background: #f4f2ff;\n}\n\n.test-suite-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.test-suite-name {\n  font-weight: 600;\n  color: var(--text-dark);\n  display: block;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-suite-pass-rate {\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n}\n\n.test-suite-pass-rate.high {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.test-suite-pass-rate.medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.test-suite-pass-rate.low {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.test-suite-item-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.test-case-count {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.test-case-status {\n  display: flex;\n  gap: 0.75rem;\n  font-size: 0.75rem;\n}\n\n.status-passed {\n  color: #28a745;\n}\n\n.status-failed {\n  color: #dc3545;\n}\n\n.status-pending {\n  color: #ffc107;\n}\n\n/* Test Suite Details */\n.test-suite-details {\n  flex: 1;\n  min-width: 0;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.test-suite-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.test-suite-header-info {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.test-suite-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.test-suite-description {\n  color: var(--text-muted);\n  margin: 0 0 1rem 0;\n}\n\n.test-suite-meta {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: flex-start !important;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.test-suite-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Test Cases List */\n.test-cases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n  width: 100%;\n  overflow-x: auto;\n}\n\n/* Test Cases */\n.test-cases-container {\n  margin-top: 1.5rem;\n}\n\n.test-cases-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.test-cases-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-top: 0;\n  margin-left: 15px;\n  /* margin-bottom: 1rem; */\n  /* padding-bottom: 0.5rem; */\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n.test-cases-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.test-cases-table th,\n.test-cases-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n.test-cases-table th {\n  font-weight: 600;\n  color: var(--text-dark);\n  background-color: #f8f9fa;\n}\n\n.test-cases-table tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n/* Priority and Status Badges */\n.priority-badge,\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.priority-high {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.priority-medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.priority-low {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n/* Priority Badge Colors - More Vibrant */\n.priority-badge.priority-high {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.priority-badge.priority-medium {\n  background-color: #fff8e1;\n  color: #f57f17;\n}\n\n.priority-badge.priority-low {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-passed {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.status-failed {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.status-pending {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n/* Status Badge Colors - More Vibrant */\n.status-badge.status-passed {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.status-failed {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.status-badge.status-pending {\n  background-color: #fff8e1;\n  color: #f57f17;\n}\n\n/* Test Case Row for Draggable List */\n.test-case-row {\n\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 0;\n  background-color: white;\n  border-radius: 0;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 0.75rem 0;\n  transition: all 0.2s ease;\n  min-height: 40px; /* Minimum height for consistency */\n}\n\n.test-case-row:hover {\n  background-color: #fafafa;\n}\n\n.test-case-row:hover {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.drag-handle {\n  padding: 0 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #eee;\n  cursor: grab;\n  height: 100%;\n  align-self: stretch;\n  opacity: 0.5;\n}\n\n.drag-handle:hover {\n  color: #999;\n  opacity: 1;\n}\n\n.test-case-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  gap: 1rem;\n}\n\n.test-case-id {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-right: 1rem;\n  margin-left: 1rem;\n  flex: 0 0 auto; /* Don't grow or shrink */\n  width: 50px;\n}\n\n.test-case-name {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text-dark);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1; /* Take up remaining space */\n  margin-right: 1rem;\n}\n\n.priority-badge, .status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-right: 1rem;\n}\n\n/* Test Case Actions */\n.test-case-actions {\n  display: flex;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: all 0.2s ease;\n}\n\n.action-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.action-btn.run:hover {\n  color: #6f42c1;\n}\n\n.action-btn.view:hover {\n  color: #17a2b8;\n}\n\n.action-btn.edit:hover {\n  color: #28a745;\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--primary-color);\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.error-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  padding: 2rem;\n}\n\n.empty-state-icon {\n  color: var(--border-color);\n  margin-bottom: 1.5rem;\n}\n\n.empty-state-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.empty-state-description {\n  color: var(--text-muted);\n  margin-bottom: 1.5rem;\n  max-width: 400px;\n}\n\n/* Test Suites Overview */\n.test-suites-overview-container {\n  padding: 1rem;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  margin: 0;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.projects-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.project-card {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem;\n  overflow: hidden;\n}\n\n.project-header {\n  margin-bottom: 1rem;\n}\n\n.project-header-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.expand-toggle {\n  background: none;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-muted);\n}\n\n.expand-toggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--primary-color);\n}\n\n.expand-toggle.expanded svg {\n  transform: rotate(180deg);\n}\n\n.project-content {\n  display: none;\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.project-content.expanded {\n  display: block;\n  opacity: 1;\n  height: auto;\n  overflow: visible;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.project-name {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--text-dark);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.project-name:hover {\n  color: var(--primary-color);\n}\n\n.project-description {\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.project-stats {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.stat-value {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-dark);\n}\n\n.pass-rate {\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n}\n\n.pass-rate.high {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.pass-rate.medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.pass-rate.low {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.test-suites-table-container {\n  margin-bottom: 1.5rem;\n  overflow-x: auto;\n}\n\n.test-suites-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.test-suites-table th,\n.test-suites-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n.test-suites-table th {\n  font-weight: 600;\n  color: var(--text-dark);\n  background-color: #f8f9fa;\n}\n\n.test-suites-table tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n.test-suite-name-cell {\n  font-weight: 500;\n  color: var(--text-dark);\n  cursor: pointer;\n}\n\n.test-suite-name-cell:hover {\n  color: var(--primary-color);\n}\n\n.pass-rate-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.pass-rate-badge.high {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.pass-rate-badge.medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.pass-rate-badge.low {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.test-suite-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.action-btn.delete:hover {\n  color: #dc3545;\n}\n\n.project-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Small Button */\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* Action Feedback */\n.action-feedback {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 20px;\n  border-radius: 4px;\n  background-color: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  z-index: 2000;\n  animation: slideIn 0.3s ease;\n  max-width: 400px;\n}\n\n.action-feedback.success {\n  border-left: 4px solid #28a745;\n}\n\n.action-feedback.error {\n  border-left: 4px solid #dc3545;\n}\n\n.action-feedback.info {\n  border-left: 4px solid #17a2b8;\n}\n\n.action-feedback button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #6c757d;\n}\n\n.action-feedback button:hover {\n  color: #343a40;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* AI Test Cases Modal */\n.add-test-cases-modal {\n  width: 90%;\n  max-width: 900px;\n  max-height: 90vh;\n}\n\n.test-cases-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.selection-summary {\n  margin: 1rem 0;\n  padding: 0.5rem;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.ai-test-cases-list {\n  max-height: 50vh;\n  overflow-y: auto;\n  padding: 0.5rem;\n  border: 1px solid var(--border-color-light);\n  border-radius: 4px;\n}\n\n.ai-test-case-item {\n  background-color: white;\n  border: 1px solid var(--border-color-light);\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ai-test-case-item:hover {\n  border-color: var(--border-color);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.ai-test-case-item.selected {\n  border-color: var(--primary-color);\n  background-color: rgba(var(--primary-rgb), 0.05);\n}\n\n.test-case-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.test-case-name-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.test-case-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.test-case-meta {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.ai-confidence {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  background-color: #f8f9fa;\n  padding: 0.25rem 0.5rem;\n  border-radius: 12px;\n}\n\n.test-case-description {\n  color: var(--text-muted);\n  margin-bottom: 1rem;\n}\n\n.test-case-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  font-size: 0.9rem;\n}\n\n.test-case-section h4 {\n  font-size: 0.9rem;\n  margin: 0 0 0.5rem 0;\n  color: var(--text-dark);\n}\n\n.test-case-section pre {\n  margin: 0;\n  white-space: pre-wrap;\n  font-family: inherit;\n  background-color: #f8f9fa;\n  padding: 0.5rem;\n  border-radius: 4px;\n  color: var(--text-muted);\n}\n\n.selection-count {\n  font-weight: 500;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Drag and Drop Styles */\n.draggable-item {\n  cursor: move;\n  user-select: none;\n}\n\n.draggable-item.dragging {\n  opacity: 0.5;\n}\n\n.drop-indicator {\n  height: 2px;\n  background-color: #7c3aed;\n  margin: 4px 0;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n.drag-handle {\n  cursor: grab;\n  color: var(--text-muted);\n  padding: 0.25rem;\n  border-radius: 4px;\n}\n\n.drag-handle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--text-dark);\n}\n\n.drag-handle svg {\n  display: block;\n}\n\n/* Drag and drop specific styles */\n.test-suite-item-wrapper.dragging {\n  opacity: 0.5;\n  background: #f8f9fa;\n}\n\n.test-suite-drop-indicator {\n  height: 2px;\n  background-color: #7c3aed;\n  margin: 4px 0;\n}\n\n.test-suite-drag-handle {\n  cursor: grab;\n  color: #666;\n  padding: 0.25rem;\n  margin-right: 0.5rem;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .test-suites-content {\n    flex-direction: column;\n    height: auto;\n  }\n  \n  .test-suites-sidebar {\n    width: 100%;\n    height: auto;\n    max-height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .test-suites-header-top {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .test-suites-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n  \n  .test-suite-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .test-suite-actions {\n    width: 100%;\n  }\n}\n\n@media (max-width: 700px) {\n  .test-case-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
